import React, { useState, useEffect, useContext, useCallback } from "react";
import { Modal, Button, Form, Row, Col, Card, Spinner } from "react-bootstrap";
import { FiSearch, FiEdit3, FiTrash2 } from "react-icons/fi";
import { toast } from "react-toastify";
import { Datacontext } from "../../context/Datacontext";

export function AdminHighlights() {
  const { highlights, setHighlights, refetch } = useContext(Datacontext);
  const [filteredHighlights, setFilteredHighlights] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [show, setShow] = useState(false);
  const [editing, setEditing] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const [form, setForm] = useState({
    title: "",
    description: "",           // optional – remove if not needed
    image: null,               // new file
    link: "",                  // ← new required field
    currentImage: "",
    isPublished: true,
  });

  // Helper: Safe image URL
  const getFileUrl = (path) => {
    if (!path) return "";
    return path.startsWith("http") ? path : `${process.env.REACT_APP_BACKEND_URL}${path}`;
  };

  const loadHighlights = useCallback(async () => {
    setLoading(true);
    try {
      if (refetch) {
        
        await refetch();
      } else {
        // Fallback
        console.log(process.env.REACT_APP_BACKEND_URL)
        const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/highlights`);
        console.log(res)
        const data = await res.json();
        const list = Array.isArray(data) ? data : data.data || [];
        setHighlights(list);
       
      }
    } catch (err) {
      toast.error("Failed to load highlights");
    } finally {
      setLoading(false);
    }
  }, [refetch, setHighlights]);

  useEffect(() => {
    loadHighlights();
  }, [loadHighlights]); // only once on mount

  // Filter
useEffect(() => {
  if (!highlights) return;

  const term = searchTerm.toLowerCase();

  const filtered = highlights.filter((item) =>
    item.title?.toLowerCase().includes(term) ||
    item.description?.toLowerCase().includes(term) ||
    item.link?.toLowerCase().includes(term)
  );

  setFilteredHighlights(filtered);
}, [searchTerm, highlights]);

  const handleClose = () => {
    setShow(false);
    setEditing(null);
    setForm({
      title: "",
      description: "",
      image: null,
      link: "",
      currentImage: "",
      isPublished: true,
    });
    // Reset file inputs
    document.querySelectorAll('input[type="file"]').forEach((input) => (input.value = ""));
  };

  const handleShow = () => setShow(true);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return;

    const token = localStorage.getItem("MagazineToken"); // ← consider renaming token key

    if (!form.title || !form.link) {
      toast.error("Title and Link are required");
      return;
    }

    setSubmitting(true);

    try {
      const data = new FormData();
      data.append("title", form.title);
      data.append("description", form.description || "");
      data.append("link", form.link);
      data.append("isPublished", form.isPublished);

      if (form.image) {
        data.append("image", form.image);
      }

      const url = editing
        ? `${process.env.REACT_APP_BACKEND_URL}/api/highlights/edit/${editing}`
        : `${process.env.REACT_APP_BACKEND_URL}/api/highlights/add`;

      const res = await fetch(url, {
        method: editing ? "PUT" : "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: data,
      });

      if (!res.ok) {
  const err = await res.text();
  throw new Error(err || "Operation failed");
}

await res.json();

      toast.success(editing ? "Highlight updated!" : "Highlight added!");
      await loadHighlights();
      handleClose();
    } catch (err) {
      toast.error("Error: " + err.message);
    } finally {
      setSubmitting(false);
    }
  };

  const editHighlight = (item) => {
    setEditing(item.id);
    setForm({
      title: item.title || "",
      description: item.description || "",
      image: null,
      link: item.link || "",
      currentImage: item.image || "",
      isPublished: item.is_published ?? true,
    });
    setShow(true);
  };

  const deleteHighlight = async (id) => {
    const token = localStorage.getItem("MagazineToken");

    

    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/highlights/delete/${id}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!res.ok) throw new Error("Delete failed");

      toast.success("Highlight deleted!");
      loadHighlights();
    } catch (err) {
      toast.error("Failed to delete");
    }
  };

  return (
    <div className="container py-2 admin-blogs-root">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="fw-bold text-dark">Highlights</h2>

        <button
          onClick={handleShow}
          aria-label="Add new highlight"
          style={{
            position: "fixed",
            bottom: "30px",
            right: "30px",
            width: "60px",
            height: "60px",
            borderRadius: "50%",
            background: "linear-gradient(135deg,#6d28d9,#4c1d95)",
            color: "white",
            border: "none",
            fontSize: "32px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            boxShadow: "0 6px 18px rgba(0,0,0,0.25)",
            cursor: "pointer",
            zIndex: 999,
            transition: "0.3s ease",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
          onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
        >
          +
        </button>
      </div>

      <div className="input-group mb-4" style={{ maxWidth: "400px" }}>
        <span className="input-group-text bg-white border-end-0">
          <FiSearch className="text-muted" />
        </span>
        <input
          type="text"
          className="form-control border-start-0 ps-0"
          placeholder="Search title, link..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      {loading ? (
        <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: "80vh" }}>
          <Spinner animation="border" variant="primary" style={{ width: "2rem", height: "2rem" }} />
          <h5 className="mt-4 text-muted">Loading highlights...</h5>
        </div>
      ) : filteredHighlights.length === 0 ? (
        <div className="text-center py-5">
          <h4 className="text-muted">
            {searchTerm ? "No matches found" : "No highlights yet"}
          </h4>
          {!searchTerm && <p className="text-muted">Click the + button to add one!</p>}
        </div>
      ) : (
        <Row>
          {filteredHighlights.map((item) => (
            <Col xl={3} sm={6} md={8} lg={4} className="mb-4" key={item.id}>
              <div className="card-wrapper">
                <Card
                  className="mag-card shadow-lg border-0 h-100 mb-10 overflow-hidden position-relative transition-all"
                  style={{
                    borderRadius: "18px",
                    transition: "transform 0.3s ease, box-shadow 0.3s ease",
                    cursor: "pointer",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-12px)";
                    e.currentTarget.style.boxShadow = "0 20px 40px rgba(0,0,0,0.25)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "0 10px 25px rgba(0,0,0,0.15)";
                  }}
                >
                  <div className="overflow-hidden" style={{ height: "210px" }}>
                    <img
                      src={getFileUrl(item.image)}
                      alt={item.title}
                      className="w-100 h-100 transition-all"
                      style={{
                        objectFit: "cover",
                        transition: "transform 0.5s ease",
                      }}
                      onError={(e) => {
                        e.target.src = "/placeholder-highlight.jpg"; // ← add fallback image
                      }}
                    />
                    {!item.is_published && (
                      <span className="blog-status-badge draft">Inactive</span>
                    )}
                  </div>

                  <Card.Body className="d-flex flex-column justify-content-between py-3">
                    <div>
                      <h5
                        className="fw-bold text-dark "
                        style={{
                          fontSize: "18px",
                          display: "-webkit-box",
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {item.title}
                      </h5>
                  
                    
                    </div>

                    <div className="d-flex gap-3 justify-content-center">
                      <Button
                        onClick={() => editHighlight(item)}
                        className="d-flex align-items-center gap-2 shadow-sm"
                        style={{
                          background: "linear-gradient(135deg,#6d28d9,#4c1d95)",
                          border: "none",
                          borderRadius: "12px",
                          padding: "9px 15px",
                        }}
                      >
                        <FiEdit3 size={18} /> Edit
                      </Button>
                      <Button
                        variant="light"
                        onClick={() => deleteHighlight(item.id)}
                        className="d-flex align-items-center gap-2 shadow-sm"
                        style={{
                          backgroundColor: "#fdf2f2",
                          color: "#c92a2a",
                          borderRadius: "12px",
                          padding: "9px 15px",
                        }}
                      >
                        <FiTrash2 size={18} /> Delete
                      </Button>
                    </div>
                  </Card.Body>
                </Card>
              </div>
            </Col>
          ))}
        </Row>
      )}

      {/* ────────────── Modal ────────────── */}
      <Modal show={show} onHide={handleClose} >
        <Modal.Header closeButton>
          <Modal.Title>{editing ? "Edit Highlight" : "Add New Highlight"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Title *</Form.Label>
              <Form.Control
                type="text"
                required
                value={form.title}
                onChange={(e) => setForm({ ...form, title: e.target.value })}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Link / URL *</Form.Label>
              <Form.Control
                type="url"
                required
                placeholder="https://example.com/article or /internal/path"
                value={form.link}
                onChange={(e) => setForm({ ...form, link: e.target.value })}
              />
            </Form.Group>

            

            <Form.Group className="mb-3">
              <Form.Label>Highlight Image *</Form.Label>
              <Form.Control
                type="file"
                accept="image/*"
                required={!editing}
                onChange={(e) =>
                  setForm({ ...form, image: e.target.files[0] || null })
                }
              />
              {form.currentImage && !form.image && (
                <div className="mt-2">
                  <small className="text-success">
                    Current: <strong>{form.currentImage.split("/").pop()}</strong>{" "}
                    (<a href={getFileUrl(form.currentImage)} target="_blank" rel="noreferrer">
                      View
                    </a>)
                  </small>
               
                </div>
              )}
            </Form.Group>

            <Form.Group className="mb-4 d-flex align-items-center">
              <Form.Check
                type="checkbox"
                id="isPublished"
                label="Active / Publish to website"
                checked={form.isPublished}
                onChange={(e) => setForm({ ...form, isPublished: e.target.checked })}
                className="me-2"
              />
            </Form.Group>

            <Button
              type="submit"
              disabled={submitting}
              className="w-100 mt-2 d-flex align-items-center justify-content-center"
              style={{
                background: "linear-gradient(90deg,#6d28d9,#4c1d95)",
                border: "none",
                opacity: submitting ? 0.8 : 1,
              }}
            >
              {submitting ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  {editing ? "Updating..." : "Adding..."}
                </>
              ) : (
                <>{editing ? "Update" : "Add"} Highlight</>
              )}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
}